import { CategoryLists } from '../CategoryKey';
import OLED, { Boxes as OLEDBoxes } from './oled';
import QLED8k, { Boxes as QLEDBoxes } from './qled';
import UHD, { Boxes as UHDBoxes } from './uhd';
import FHD, { Boxes as FHDBoxes } from './fhd';
import HD, { Boxes as HDBoxes } from './hd';
import Serif, { Boxes as SerifBoxes } from './serif';
import Sero, { Boxes as SeroBoxes } from './sero';
import Frame, { Boxes as FrameBoxes } from './frame';
import Terrace, { Boxes as TerraceBoxes } from './terrace';
import Premiere, { Boxes as PremiereBoxes } from './premiere';
import Monitor, { Boxes as MonitorBoxes } from './monitors';
import OdysseyArk, { Boxes as OdysseyArkBoxes } from './ark';
import Soundbar, { Boxes as SoundbarBoxes } from './soundbar';
import SoundbarSetOne, { Boxes as SoundbarSetOneBoxes } from './soundbarset01';
import SoundbarSetTwo, { Boxes as SoundbarSetTwoBoxes } from './soundbarset02';
import TheTerraceSoundBar, {Boxes as TheTerraceSoundBarBoxes} from './theterracesoundbar';
import SoundTower, {Boxes as SoundTowerBoxes} from './soundtower';
import BespokeJet, {Boxes as BespokeJetBoxes} from './bespoke_jet';
import BespokeJetStation, {Boxes as BespokeJetStationBoxes} from './bespoke_jetstation';
import BespokeJetNCleanStation, {Boxes as BespokeJetNCleanStationBoxes} from './bespoke_jetNcleanstation';
import BespokeSlim, {Boxes as BespokeSlimBoxes} from './bespoke_slim';
import BespokeSlimCleanStation, {Boxes as BespokeSlimCleanStationBoxes} from './bespoke_slim_cleanstation';
import JetCleanStation, {Boxes as JetCleanStationBoxes} from './jet_cleanstation';
import BespokeJetbot, {Boxes as BespokeJetbotBoxes} from './bespke_jetbot';
import BespokeJetbotPlus, {Boxes as BespokeJetbotPlusBoxes} from './bespke_jetbotplus';
import BespokeJetbotAI, {Boxes as BespokeJetbotAIBoxes} from './bespke_jetbotAI';
import Canister01, {Boxes as Canister01Boxes} from './canister01';
import Canister02, {Boxes as Canister02Boxes} from './canister02';
import Jupiter, {Boxes as JupiterBoxes} from './jupiter';
import BespokeCube53, {Boxes as BespokeCube53Boxes} from './bespoke_cube53';
import BespokeCube70, {Boxes as BespokeCube70Boxes} from './bespoke_cube70';
import BespokeCube106, {Boxes as BespokeCube106Boxes} from './bespoke_cube106';
import BespokeCube123, {Boxes as BespokeCube123Boxes} from './bespoke_cube123';
import BlueSky, {Boxes as BlueSkyBoxes} from './bluesky';//bluesky5500
import BlueSky3000, {Boxes as BlueSky3000Boxes} from './bluesky3000';
import BlueSky3100, {Boxes as BlueSky3100Boxes} from './bluesky3100';
import BlueSky5000, {Boxes as BlueSky5000Boxes} from './bluesky5000';
import Qooker, {Boxes as QookerBoxes} from './qooker';
import WaterPurifier, {Boxes as WaterPurifierBoxes} from './waterpurifier';
import LATIN, {Boxes as LATINBoxes} from './latin';
import LATIN10, {Boxes as LATIN10Boxes} from './latin10';
import MIRROR, {Boxes as MIRRORBoxes} from './mirror';
import MW5100J, {Boxes as MW5100JBoxes} from './mw5100j';
import STENA, {Boxes as STENABoxes} from './stena';
import TheFreeStyle, {Boxes as TheFreeStyleBoxes} from './thefreestyle';
import ref_cube, {Boxes as ref_cubeBoxes} from './ref_cube';

const {QLED,Lifestyle, Monitors, HomeAudio, Vacuum, Airpurifier, Microwaves, Refrigerator } = CategoryLists; 


export const categories = {
  [QLED.list.OLED.url]:OLED,
  [QLED.list.QLED8k.url]: QLED8k,
  [QLED.list.UHD.url]: UHD,
  [QLED.list.FHD.url]: FHD,
  [QLED.list.HD.url]: HD,
  [Lifestyle.list.Serif.url]: Serif,
  [Lifestyle.list.Frame.url]: Frame,
  [Lifestyle.list.Sero.url]: Sero,
  [Lifestyle.list.Terrace.url]: Terrace,
  [Lifestyle.list.Premiere.url]: Premiere,
  [Lifestyle.list.TheFreeStyle.url]: TheFreeStyle,
  [Monitors.list.GamingMonitor.url]: Monitor,
  [Monitors.list.OdysseyArk.url]: OdysseyArk,
  [HomeAudio.list.Soundbar.url]: Soundbar,
  [HomeAudio.list.SoundbarSetOne.url]: SoundbarSetOne,
  [HomeAudio.list.SoundbarSetTwo.url]: SoundbarSetTwo,
  [HomeAudio.list.TheTerraceSoundBar.url]: TheTerraceSoundBar,
  [HomeAudio.list.SoundTower.url]:SoundTower,
  [Vacuum.list.BespokeJet.url]:BespokeJet,
  [Vacuum.list.BespokeJetStation.url]:BespokeJetStation,
  [Vacuum.list.BespokeJetNCleanStation.url]:BespokeJetNCleanStation,
  [Vacuum.list.BespokeSlim.url]:BespokeSlim,
  [Vacuum.list.BespokeSlimCleanStation.url]:BespokeSlimCleanStation,
  [Vacuum.list.JetCleanStation.url]:JetCleanStation,
  [Vacuum.list.BespokeJetbot.url]:BespokeJetbot,
  [Vacuum.list.BespokeJetbotPlus.url]:BespokeJetbotPlus,
  [Vacuum.list.BespokeJetbotAI.url]:BespokeJetbotAI,
  [Vacuum.list.Canister01.url]:Canister01,
  [Vacuum.list.Canister02.url]:Canister02,
  [Vacuum.list.Jupiter.url]:Jupiter,
  [Airpurifier.list.BespokeCube53.url]:BespokeCube53,
  [Airpurifier.list.BespokeCube70.url]:BespokeCube70,
  [Airpurifier.list.BespokeCube106.url]:BespokeCube106,
  [Airpurifier.list.BespokeCube123.url]:BespokeCube123,
  [Airpurifier.list.BlueSky.url]:BlueSky,
  [Airpurifier.list.BlueSky3000.url]:BlueSky3000,
  [Airpurifier.list.BlueSky3100.url]:BlueSky3100,
  [Airpurifier.list.BlueSky5000.url]:BlueSky5000,
  [Microwaves.list.WaterPurifier.url]:WaterPurifier,
  [Microwaves.list.Qooker.url]:Qooker,
  [Microwaves.list.LATIN.url]:LATIN,
  [Microwaves.list.LATIN10.url]:LATIN10,
  [Microwaves.list.MIRROR.url]:MIRROR,
  [Microwaves.list.MW5100J.url]:MW5100J,
  [Microwaves.list.STENA.url]:STENA,
  [Refrigerator.list.ref_cube.url]:ref_cube,
};

export const Models = {
  ...OLEDBoxes,
  ...QLEDBoxes,
  ...UHDBoxes,
  ...FHDBoxes,
  ...HDBoxes,
  ...SerifBoxes,
  ...SeroBoxes,
  ...FrameBoxes,
  ...TerraceBoxes,
  ...PremiereBoxes,
  ...MonitorBoxes,
  ...OdysseyArkBoxes,
  ...SoundbarBoxes,
  ...SoundbarSetOneBoxes,
  ...SoundbarSetTwoBoxes,
  ...TheTerraceSoundBarBoxes,
  ...SoundTowerBoxes,
  ...BespokeJetBoxes,
  ...BespokeJetStationBoxes,
  ...BespokeJetNCleanStationBoxes,
  ...BespokeSlimBoxes,
  ...BespokeCube53Boxes,
  ...BespokeCube70Boxes,
  ...BespokeCube106Boxes,
  ...BespokeCube123Boxes,
  ...BlueSkyBoxes,
  ...BlueSky3000Boxes,
  ...BlueSky3100Boxes,
  ...BlueSky5000Boxes,
  ...QookerBoxes,
  ...TheFreeStyleBoxes,
  ...BespokeSlimCleanStationBoxes,
  ...JetCleanStationBoxes,
  ...BespokeJetbotBoxes,
  ...BespokeJetbotPlusBoxes,
  ...BespokeJetbotAIBoxes,
  ...Canister01Boxes,
  ...Canister02Boxes,
  ...JupiterBoxes,
  ...ref_cubeBoxes,
  ...WaterPurifierBoxes,
  ...LATINBoxes,
  ...LATIN10Boxes,
  ...MIRRORBoxes,
  ...MW5100JBoxes,
  ...STENABoxes,
};
